import React, { useState, useContext } from "react";
import { Button } from "@material-ui/core";
import { UserDataContext } from "../Contexts/UserDataContext";
import { downloadData } from "../GlobalFunctions";

const axios = require("axios");

function ButtonOverride(props) {
  const { itemId, ...otherProps } = props;
  const { userData } = useContext(UserDataContext);

  //   const sendPdfRequest = async () => {
  //   // window.open("/invoices/GeneratePdfInvoice/318-20200524"); // this opens properly

  //   try {
  //     const res = await axios({
  //       method: "GET",
  //       url: `/invoices/GeneratePdfInvoice/${invoice.id}`,
  //       headers: {
  //         Authorization: `bearer ${userData.token}`,
  //         "Content-Type": "application/pdf",
  //       },
  //       responseType: "arraybuffer",
  //     });

  //     const blob = new Blob([res.data], { type: "application/pdf" });
  //     const url = URL.createObjectURL(blob);
  //     window.open(url); // this opens a blank pdf

  //     setTimeout(function () {
  //       window.URL.revokeObjectURL(url);
  //     }, 0);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const downloadFile = async () => {
    try {
      const res = await axios({
        method: "GET",
        url: `files/download/${itemId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userData.token}`,
        },
      });
      res.data.forEach((file) => {
        downloadData(file);
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Button {...otherProps} onClick={downloadFile}>
      Download
    </Button>
  );
}

export default ButtonOverride;
